var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypePowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9443 4.58236L12.486 1.08236C12.111 0.707357 11.5693 0.499023 11.0693 0.499023H2.56934C1.44434 0.499023 0.569336 1.41569 0.569336 2.49902V19.8324C0.569336 20.9574 1.44434 21.8324 2.56934 21.8324H14.5693C15.6527 21.8324 16.5693 20.9574 16.5693 19.8324V5.99902C16.5693 5.49902 16.3193 4.95736 15.9443 4.58236ZM14.4027 5.83236H11.236V2.66569L14.4027 5.83236ZM2.56934 19.8324V2.49902H9.236V6.83236C9.236 7.41569 9.65267 7.83236 10.236 7.83236H14.5693V19.8324H2.56934ZM5.56934 17.3324C5.56934 17.624 5.77767 17.8324 6.06934 17.8324H7.06934C7.361 17.8324 7.56934 17.624 7.56934 17.3324V15.374C8.69434 15.374 11.5693 15.7074 11.5693 12.624C11.5693 10.9574 10.4443 9.83236 8.94434 9.83236H6.06934C5.77767 9.83236 5.56934 10.0824 5.56934 10.3324V17.3324ZM7.56934 13.7074V11.5407H8.56934C8.861 11.5407 9.111 11.624 9.27767 11.8324C9.65267 12.2074 9.65267 12.999 9.27767 13.4157C9.111 13.624 8.861 13.7074 8.52767 13.7074H7.56934Z",
    fill: "#49454F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypePowerpoint);
export default __webpack_public_path__ + "static/media/File_Type_Powerpoint.c03f355a090da2c01c4eeb415134c104.svg";
export { ForwardRef as ReactComponent };